// Import wizard (/app/import) i18n. FR + EN curated; 20 languages LLM-generated
// in import_i18n_gen.js and merged. {n} placeholder interpolated by il().
import { IMPORT_GEN } from "@/i18n/import_i18n_gen";

const IMPORT_UI = {
  fr: {
    title: "Assistant d'import",
    subtitle: "Importez vos animaux, clients, produits et stocks depuis un fichier CSV ou Excel.",
    columns: "{n} colonnes",
    changeType: "Changer de type",
    expectedColumns: "Colonnes attendues :",
    downloadTemplate: "Télécharger le modèle",
    dropzone: "Cliquez pour choisir un fichier CSV ou Excel",
    fileHint: ".csv, .xlsx — max 5 Mo",
    analyzing: "Analyse du fichier…",
    validRows: "{n} ligne(s) valide(s)",
    errorRows: "{n} ligne(s) en erreur",
    recognizedColumns: "Colonnes reconnues :",
    previewNote: "Aperçu des {n} premières lignes.",
    lineLabel: "Ligne",
    importBtn: "Importer {n} ligne(s)",
    cancel: "Annuler",
    successMsg: "{n} élément(s) importé(s) avec succès 🎉",
    skipped: "{n} ligne(s) ignorée(s) pour erreurs.",
    importAnother: "Importer un autre fichier",
    imported: "{n} élément(s) importé(s)",
  },
  en: {
    title: "Import wizard",
    subtitle: "Import your animals, customers, products and stock from a CSV or Excel file.",
    columns: "{n} columns",
    changeType: "Change type",
    expectedColumns: "Expected columns:",
    downloadTemplate: "Download template",
    dropzone: "Click to choose a CSV or Excel file",
    fileHint: ".csv, .xlsx — max 5 MB",
    analyzing: "Analyzing file…",
    validRows: "{n} valid row(s)",
    errorRows: "{n} row(s) with errors",
    recognizedColumns: "Recognized columns:",
    previewNote: "Preview of the first {n} rows.",
    lineLabel: "Row",
    importBtn: "Import {n} row(s)",
    cancel: "Cancel",
    successMsg: "{n} item(s) imported successfully 🎉",
    skipped: "{n} row(s) skipped due to errors.",
    importAnother: "Import another file",
    imported: "{n} item(s) imported",
  },
  ...Object.fromEntries(Object.entries(IMPORT_GEN).map(([lg, d]) => [lg, d.ui])),
};

const RES_LABELS = {
  fr: { customers: "Clients", products: "Produits", "inventory-items": "Stock", "animal-batches": "Élevage / Animaux" },
  en: { customers: "Customers", products: "Products", "inventory-items": "Stock", "animal-batches": "Livestock / Animals" },
  ...Object.fromEntries(Object.entries(IMPORT_GEN).map(([lg, d]) => [lg, d.res])),
};

const _interp = (s, args) => (typeof s === "string" ? s.replace(/\{n\}/g, () => (args[0] != null ? args[0] : "")) : s);

export const il = (lang, key, ...args) => _interp((IMPORT_UI[lang] || IMPORT_UI.en)[key] ?? IMPORT_UI.en[key] ?? key, args);

export const resLabel = (lang, resource, fallback) => (RES_LABELS[lang] || RES_LABELS.en)[resource] || RES_LABELS.en[resource] || fallback || resource;

const NAV_IMPORT = {
  fr: "Importer", en: "Import", es: "Importar", it: "Importa", de: "Import", nl: "Importeren",
  sv: "Importera", da: "Importér", bg: "Импортиране", el: "Εισαγωγή", hr: "Uvoz", et: "Impordi",
  fi: "Tuo", hu: "Importálás", lv: "Importēt", lt: "Importuoti", pl: "Import", pt: "Importar",
  ro: "Import", sk: "Import", sl: "Uvoz", cs: "Import",
};

export const navImport = (lang) => NAV_IMPORT[lang] || NAV_IMPORT.en;
